
import { Injectable } from '@angular/core';
import { QueryResult } from '../../../common/rest-api/models/query-result';
import { RestApiService } from '../../../common/rest-api/services/rest-api.service';
import { AssignedMessages } from '../models/assigned-messages.model';
  
@Injectable({
providedIn: 'root',
})
export class GarmentRepairService extends RestApiService<AssignedMessages> {

    protected resourcePath = '/assigned-message';
    protected modelType = AssignedMessages;

    async postMessage(messageCode: string[], garmentCode: string): Promise<QueryResult<AssignedMessages>> {
        const url = this.buildEndpointUrl(`${messageCode}/${garmentCode}`);
        const response = await this.cloudApiMiddleware.cloudRequest<QueryResult<AssignedMessages>>({
            url
        }, 'POST');

        return response;
    }
    async postRepairMessage(messageCode: string[], garmentCode: string): Promise<QueryResult<AssignedMessages>> {
        const messageCodeStr = messageCode.join(',');
        const encodedMessageCode = encodeURIComponent(messageCodeStr);
        const url = this.buildEndpointUrl(`${garmentCode}?messageCodes=${encodedMessageCode}`);
        const response = await this.cloudApiMiddleware.cloudRequest<QueryResult<AssignedMessages>>({
            url,
        }, 'POST');

        return response;
    }
  async saveRepairMessage(
    messageCode: string[],
    garmentCode: string,
    captchaToken: string
): Promise<string> {

    const formData = new FormData();
    formData.append("messageCodes", messageCode.join(','));
    formData.append("token", captchaToken);

    const url = this.buildEndpointUrl(`repair/${garmentCode}`);

    const response = await this.cloudApiMiddleware.cloudRequest<string>({
        url,
        body: {
        messageCodes: messageCode.join(','),
        token: captchaToken
    }
    }, 'POST');

    return response;
}
}